import { lazy, Suspense, type ComponentType, type ReactNode } from "react";

/**
 * Lazy handles for the Clerk-React-touching AUTH UI, so route modules
 * (which load in the main chunk) never statically pull in
 * `@clerk/clerk-react`. Each is only ever rendered in b2c mode, inside the
 * lazily-loaded <ClerkApp> provider, so the Clerk chunk loads once on
 * demand and never for enterprise/dev. Team management is native
 * (features/team) and needs no lazy indirection.
 */
const ClerkGateLazy = lazy(() =>
  import("./clerk-ui.js").then((m) => ({ default: m.ClerkGate })),
);
const ClerkHeaderControlsLazy = lazy(() =>
  import("./clerk-ui.js").then((m) => ({ default: m.ClerkHeaderControls })),
);

function wrap<P extends object>(
  Comp: ComponentType<P>,
  fallback: ReactNode,
): ComponentType<P> {
  return (props: P) => (
    <Suspense fallback={fallback}>
      <Comp {...props} />
    </Suspense>
  );
}

export const Splash = (
  <div className="min-h-[60vh] flex items-center justify-center">
    <span
      aria-hidden="true"
      className="h-6 w-6 rounded-full border-2 border-white/15 border-t-[var(--color-mx-electric)] animate-spin"
    />
  </div>
);

export const ClerkGate = wrap<{ children: ReactNode }>(ClerkGateLazy, Splash);
// Header chrome pops in once loaded — no fallback to avoid layout shift.
export const ClerkHeaderControls = wrap<Record<string, never>>(
  ClerkHeaderControlsLazy,
  null,
);
